const GLOBAL_REPORT_RESULTS_BAR_SIZE = 80;
const GLOBAL_REPORT_RESULTS_DAILY_BAR_CATEGORY_GAP = "25%";

const getGlobalReportResultsBarChartLayout = ({
  breakdown = "weekly",
} = {}) => {
  if (breakdown === "daily") {
    return {
      barSize: null,
      maxBarSize: GLOBAL_REPORT_RESULTS_BAR_SIZE,
      barCategoryGap: GLOBAL_REPORT_RESULTS_DAILY_BAR_CATEGORY_GAP,
    };
  }

  return {
    barSize: GLOBAL_REPORT_RESULTS_BAR_SIZE,
    maxBarSize: null,
    barCategoryGap: null,
  };
};

export default getGlobalReportResultsBarChartLayout;
